import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    localStorage.setItem('darkMode', 'false');
    document.body.classList.remove('dark-mode');
    document.body.classList.add('light-mode');
    document.documentElement.setAttribute('data-bs-theme', 'light');
  }, []);

  const toggleDarkMode = () => {};

  return (
    <ThemeContext.Provider value={{ darkMode, setDarkMode, toggleDarkMode }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
